import { sendBrowserNotification } from "services/pushNotificationService/BrowserNotificationsService";
import i18n from "i18n/config";
import { ILobbyGuest } from "../types";

export const getMessageToShow = (guests: ILobbyGuest[]): string => {
  if (guests.length === 1) {
    return i18n.t("user.has.entered.lobby");
  }

  return i18n.t("guests.in.lobby", { key: guests.length });
};

export const showLobbyNotification = (guests: ILobbyGuest[]) => {
  sendBrowserNotification(getMessageToShow(guests), {
    skipFocusCheck: true,
  });
};
